"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports.default = Asset;

var _react = _interopRequireDefault(require("react"));

var _Utils = require("../Utils/Utils");

require("../Styles/Assets.styles.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function Asset(_ref) {
  var assetDetails = _ref.assetDetails,
    selectAsset = _ref.selectAsset;
  var name = assetDetails.name,
    bttl_size = assetDetails.bttl_size,
    desc_long = assetDetails.desc_long,
    abv = assetDetails.abv,
    age = assetDetails.age,
    Distillery = assetDetails.Distillery,
    price = assetDetails.price,
    MetaplexLink = assetDetails.Files,
    cover = assetDetails.cover;

  var formatDescription = function formatDescription() {
    if (desc_long && desc_long.indexOf(".") > -1) {
      var descriptionSlugArr = desc_long.split(" ", 20);
      if (descriptionSlugArr.length === 20)
        return descriptionSlugArr.join(" ").concat("...");
      return descriptionSlugArr.join(" ");
    }

    return desc_long || "";
  };

  return /*#__PURE__*/ _react.default.createElement(
    "div",
    {
      className: "assetWrapper",
    },
    /*#__PURE__*/ _react.default.createElement("div", {
      className: "assetBg",
    }),
    /*#__PURE__*/ _react.default.createElement(
      "div",
      {
        className: "assetClickableWrapper",
        onClick: function onClick() {
          return selectAsset(assetDetails);
        },
      },
      /*#__PURE__*/ _react.default.createElement(
        "div",
        {
          className: "assetImgWrapper",
        },
        /*#__PURE__*/ _react.default.createElement("img", {
          src: cover,
          alt: name,
        })
      ),
      /*#__PURE__*/ _react.default.createElement(
        "div",
        {
          className: "assetDetailsWrapper",
        },
        /*#__PURE__*/ _react.default.createElement(
          "h3",
          {
            className: "assetNameHeader",
          },
          name
        ),
        /*#__PURE__*/ _react.default.createElement(
          "div",
          {
            className: "assetDetailsArea",
          },
          /*#__PURE__*/ _react.default.createElement(
            "div",
            {
              className: "assetDetailsAreaRow",
            },
            /*#__PURE__*/ _react.default.createElement(
              "p",
              null,
              "ABV: ",
              abv ? "".concat(abv, "%") : ""
            ),
            /*#__PURE__*/ _react.default.createElement(
              "p",
              null,
              "Size: ",
              bttl_size ? "".concat(bttl_size, "ml") : ""
            )
          ),
          /*#__PURE__*/ _react.default.createElement(
            "div",
            {
              className: "assetDetailsAreaRow",
            },
            /*#__PURE__*/ _react.default.createElement(
              "p",
              null,
              "Distillery: ",
              Distillery ? "".concat(Distillery) : ""
            ),
            /*#__PURE__*/ _react.default.createElement(
              "p",
              null,
              "Age: ",
              age ? "".concat(age) : "NAS"
            )
          )
        ),
        /*#__PURE__*/ _react.default.createElement(
          "p",
          {
            className: "assetDescription",
          },
          formatDescription()
        )
      )
    ),
    price &&
      /*#__PURE__*/ _react.default.createElement(
        "div",
        {
          className: "assetPriceArea",
        },
        /*#__PURE__*/ _react.default.createElement(
          "h4",
          null,
          _Utils.USDFormatter.format(price)
        ),
        price &&
          /*#__PURE__*/ _react.default.createElement(
            "button",
            {
              className: "assetPurchaseCTA",
            },
            /*#__PURE__*/ _react.default.createElement(
              "a",
              {
                href: price,
                target: "_blank",
                rel: "noreferrer",
              },
              "Buy Now"
            )
          )
      )
  );
}
